<template>
<div>
    <div v-if="!initialized" style="height: 100vh; position: absolute; left: 55%; top: 10%;">
        <!-- <vue-spinner></vue-spinner> -->
    </div>
    <template v-else>
        <b-card no-body style="height: 100vh">
            <div class="tabs">
                <div :class="['card-header', sections.length == 1 ? 'hide' : '']">
                    <ul role="tablist" tabindex="0" class="nav nav-tabs card-header-tabs">
                        <li v-for="section in _.slice(sections, 1)"
                            v-if="isSectionEnabled(topLevelType, section.name)"
                            :key="section.name + section.link"
                            :class="['nav-item']"
                            role="presentation">
                            <a role="tab" tabindex="-1" v-on:click="changeTab(section)"
                                          :class="['nav-link', section.active ? 'active' : '']">
                                {{ __(section.label || section.name, ['titleCase']) }}</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content tab-content-shadow p-2">
                    <div role="tabpanel" class="tab-pane card-body show fade active" style="min-height: 2rem">
                        <div class="row">
                            <div class="col-sm-6">
                                <h2 class="content-header">
                                    {{
                                    _.chain(breadcrumb).last().get('label').value() ||
                                    _.chain(breadcrumb).last().get('name').str(['titleCase']).value()
                                    }}
                                </h2>
                                <ul v-if="breadcrumbDisplay" class="breadcrumb">
                                    <template v-for="node in breadcrumb">
                                        <li :key="node.name + node.link" v-if="node.link">
                                            <a v-on:click="changeBreadcrumbLink(node.link)">{{ node.label || __(node.name, ['titleCase']) }}</a>
                                        </li>
                                        <li :key="node.name + node.link" v-else>{{ node.label || __(node.name, ['titleCase']) }}</li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 text-right">
                                <content-toolbar-component
                                    :content="localContent"
                                    :timestamp="localTimestamp"
                                    :dirty="dirty"
                                    :contentErrors="contentErrors"
                                    :selected="selected"

                                    :changeUrl="changeUrl"
                                    :changeQuery="changeQuery"
                                    :changeSection="changeSection"

                                    :componentName="componentName"
                                    :componentConfig="componentConfig"

                                    :haltFetch="signalHaltFetch"
                                    :createData="createDataPostMessage"
                                    :updateBatch="updateBatchPostMessage"
                                    :updateData="updateDataPostMessage"
                                    :deleteData="deleteDataPostMessage"
                                    :commitQueue="commitQueue"

                                    :updateParent="updateParent"
                                    :addNotification="addNotification"

                                    v-on:content::creating="loadNewInstance"
                                    v-on:content::created="doNothing"
                                    v-on:content::updated="resetLocalState"
                                    v-on:content::deleted="backToCollection"
                                    ></content-toolbar-component>
                            </div>
                        </div>
                        <div class="row">
                            <div role="tabpanel" class="tab-pane card-body show fade active">
                                <!-- main content -->
                                <div class="p-3">
                                    <component
                                        v-if="getComponentForType(fulltype)"
                                        v-bind="getConfigForType(fulltype)"
                                        :is="getComponentForType(fulltype)"
                                        :loading="loading"
                                        :key="resourcePath"

                                        :getData="getData"
                                        :createData="createDataPostMessage"
                                        :updateBatch="updateBatchPostMessage"
                                        :updateData="updateDataPostMessage"
                                        :deleteData="deleteDataPostMessage"
                                        :replaceData="replaceData"

                                        :changeUrl="changeUrl"
                                        :changeQuery="changeQuery"
                                        :changeSection="changeSection"
                                        :addNotification="addNotification"
                                        :haltFetch="signalHaltFetch"
                                        :commitQueue="commitQueue"

                                        :query="query"
                                        :timestamp="timestamp"
                                        :content="localContent"
                                        :resourceParams="resourceParams"

                                        v-on:content::initialized="updateComponent"
                                        v-on:content::creating="loadNewInstance"
                                        v-on:content::created="doNothing"
                                        v-on:content::updated="resetLocalState"
                                        v-on:content::changed="updateLocalContentPostMessage"
                                        v-on:content::deleted="backToCollection"
                                        v-on:content::selected="updateSelected"
                                        ></component>
                                    <content-view-component
                                        v-else
                                        :type="fulltype"
                                        :loading="loading"
                                        :showLoading="currentSection !== previousSection"

                                        :getData="getData"
                                        :createData="createDataPostMessage"
                                        :updateBatch="updateBatchPostMessage"
                                        :updateData="updateDataPostMessage"
                                        :deleteData="deleteDataPostMessage"

                                        :changeUrl="changeUrlForSubSection"
                                        :changeQuery="changeQuery"
                                        :changeSection="changeSection"
                                        :addNotification="addNotification"
                                        :commitQueue="commitQueue"
                                        :pushQueue="pushQueue"

                                        :selected="selected"
                                        :resourceParams="resourceParams"
                                        :section="section"
                                        :content="localContent"
                                        :parent="parent"
                                        :timestamp="timestamp"
                                        :query="query"
                                        :contentType="contentType"
                                        :relationship="relationship"
                                        :haltFetch="signalHaltFetch"

                                        v-on:content::initialized="updateComponent"
                                        v-on:content::creating="loadNewInstance"
                                        v-on:content::created="doNothing"
                                        v-on:content::updated="resetLocalState"
                                        v-on:content::changed="updateLocalContentPostMessage"
                                        v-on:content::deleted="backToCollection"
                                        v-on:content::selected="updateSelected"
                                        ></content-view-component>
                                </div>
                                <!-- end main content -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 text-right">
                                <content-toolbar-component
                                    :content="localContent"
                                    :timestamp="localTimestamp"
                                    :dirty="dirty"
                                    :contentErrors="contentErrors"
                                    :selected="selected"

                                    :changeUrl="changeUrl"
                                    :changeQuery="changeQuery"
                                    :changeSection="changeSection"

                                    :componentName="componentName"
                                    :componentConfig="componentConfig"

                                    :haltFetch="signalHaltFetch"
                                    :createData="createDataPostMessage"
                                    :updateBatch="updateBatchPostMessage"
                                    :updateData="updateDataPostMessage"
                                    :deleteData="deleteDataPostMessage"
                                    :commitQueue="commitQueue"

                                    :updateParent="updateParent"
                                    :addNotification="addNotification"

                                    v-on:content::creating="loadNewInstance"
                                    v-on:content::created="doNothing"
                                    v-on:content::updated="resetLocalState"
                                    v-on:content::deleted="backToCollection"
                                    ></content-toolbar-component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </template>
</div>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import V from 'voca';
import { plural, singular } from 'pluralize';

import Notifications from 'vue-notification';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import BaseContentComponent from './BaseContentComponent';
import ContentViewComponent from './ContentViewComponent';
import ControlPanelComponent from './ControlPanelComponent';
import ContentToolbarComponent from './helpers/ContentToolbarComponent';
import ToplevelToolbarComponent from './helpers/ToplevelToolbarComponent';
import GlobalFileModalComponent from './helpers/GlobalFileModalComponent';

export default {
    extends: BaseContentComponent,

    components: {
        ContentViewComponent,
        ControlPanelComponent,
        ContentToolbarComponent,
        ToplevelToolbarComponent,
        GlobalFileModalComponent,
        VueSpinner: MoonLoader,
    },

    created() {
        this._handlers = {
            'model:load': (data) => {
                window.location.href = '#/' + data.payload;
            },
        }

        document.body.classList.add('overflow-x-hidden');
        window.onmessage = (e) => {
            const data = e.data;
            const type = _.get(e, 'data.type');
            if (this._handlers[type]) {
                this._handlers[type](data);
            }

            if (type == 'content:initialized') {
                this.contentWindow.postMessage({
                    type: 'model:loaded',
                    payload: {
                        id: this.resourceParams.id,
                        type: this.resourceParams.endpoint,
                    },
                })
            }
        }
    },

    watch: {
        resourceParams: {
            handler(newVal) {
                this.contentWindow.postMessage({
                    type: 'model:loaded',
                    payload: {
                        id: newVal.id,
                        type: newVal.endpoint,
                    },
                })
            },
            deep: true,
            immediate: true,
        }
    },

    computed: {
        contentActive() {
            return _.get(this.localContent, 'meta.active');
        },

        contentWindow() {
            const mainIframe = document.getElementById('mainIframe');

            return mainIframe ? mainIframe.contentWindow : {
                postMessage: console.log
            };
        }
    },

    methods: {
        updateLocalContentPostMessage(payload) {
            const updatedData = {
                id: this.localContent.id,
                type: this.localContent.type,
                attributes: _.chain(payload.data)
                    .toPairs()
                    .filter(([key, val]) => {
                        return val != _.get(this.localContent, ['attributes', key]);
                    })
                    .fromPairs()
                    .value(),
            }

            this.updateLocalContent(payload);

            this.contentWindow.postMessage({
                type: 'model:changed',
                payload: updatedData,
            });

            return;
            if (this.contentActive) {
                this.contentWindow.postMessage({
                    type: 'model:activated',
                    payload: this.localContent,
                });
            } else {
                this.contentWindow.postMessage({
                    type: 'model:deactivated',
                    payload: this.localContent,
                });
            }
        },

        // modify top level API methods so that
        // they accept multiple arguments instead of just 1
        createDataPostMessage(data, options) {
            return this.modifiedCreateData(data, options)
                .then(() => {
                    this.contentWindow.postMessage({
                        type: 'model:created',
                        payload: this.content,
                    })
                })
        },

        updateDataPostMessage(data, options) {
            return this.modifiedUpdateData(data, options)
                .then(() => {
                    this.contentWindow.postMessage({
                        type: 'model:updated',
                        payload: this.content,
                    })
                })
        },

        updateBatchPostMessage(data, options) {
            return this.modifiedUpdateBatch(data, options)
                .then(() => {
                    this.contentWindow.postMessage({
                        type: 'model:batchUpdated',
                        payload: this.content,
                    })
                })
        },

        deleteDataPostMessage(options) {
            return this.deleteData(options)
                .then(() => {
                    this.contentWindow.postMessage({
                        type: 'model:deleted',
                        payload: this.content,
                    })
                })
        },
    },
}
</script>
<style>
.card-body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/PageEditorComponent.vue